export default __webpack_public_path__ + "static/media/Reset-Filter.c81d5a74.svg";